import React, { FC } from "react";
import classNames from "classnames";
import { cdn } from "constants/media";
import { ICollectionSwatch, SwatchType } from "constants/color-swatches";

export const ColorSwatchCircles: FC<Omit<ICollectionSwatch, "color" | "label">> = ({
    selected,
    swatch_type,
    value,
}) => {
    const style =
        swatch_type === SwatchType.FILE
            ? {
                  backgroundImage: `url("//${cdn}/brand_color_swatch/${value}.jpg")`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
              }
            : { backgroundColor: `#${value}` };

    return (
        <div className={classNames("colorSwatchContainer", { selected })}>
            <div className="colorSwatch" style={style} />
        </div>
    );
};
